import * as React from 'react'
import { getStaticSlugsPaths } from '../../../../helpers/nextHelpers'
import type { SlugsStaticType } from '../../../../helpers/nextHelpers'
import { withRouter } from 'next/router'
import {
  getCanonicalSlug,
  getMoreLikeTracks,
  getMoreLikeTracksSlugs,
  getTrackBySlugAsync
} from '../../../../models/Track'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import type { TrackPropsType } from '../../../../models/Track'
import { TrackListItemComponent } from '@components/Track/TrackListItem'
import { PageTitle } from '@components/shared/PageTitle'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import { colors } from '@components/shared'
import { Loading } from '@components/shared/Loading'

function GetTracksList (props: {trackId: string}): React.ReactNode {
  const [tracks, setTracks] = React.useState<TrackPropsType[]>([])
  React.useEffect((): void => {
    getMoreLikeTracks(props.trackId).then((tracks: TrackPropsType[]): void => {
      setTracks(tracks)
    })
  }, [props.trackId])
  if (tracks.length === 0) {
    return <Loading height={'100px'}/>
  }
  return <>{tracks.map((track: TrackPropsType): React.ReactNode => (
    <SectionDivider key={track.id}>
      <TrackListItemComponent {...track}/>
    </SectionDivider>
  ))}</>
}

function MoreLikeTrack (props: { title: string, trackId: string, slug: string}): React.ReactNode {
  return (
    <DiscoverLayout
      title={`More Stories like ${props.title} on Dipsea`}
      description={`Listen to more stories featuring themes in ${props.title} on Dipsea`}
      canonicalUrl={`https://www.dipseastories.com/chapters/more-like/${props.slug.replace('/stories/', '').replace('/chapters/', '')}`}
    >
      <PageTitle title={`More Like ${props.title}`}/>
      <GetTracksList trackId={props.trackId}/>
    </DiscoverLayout>
  )
}
export default withRouter(MoreLikeTrack as any) as any

type ContextType = {
  params: {
    slug: string
  }
}
export async function getStaticProps (
  context: ContextType
): Promise<{ props: {title: string, trackId: string, slug: string }}> {
  const track = await getTrackBySlugAsync(context.params.slug)
  const slug = getCanonicalSlug(track)
  return { props: { title: track.title, trackId: track.id, slug } }
}
export async function getStaticPaths (): Promise<SlugsStaticType> {
  const slugs = await getMoreLikeTracksSlugs()
  return getStaticSlugsPaths(slugs)
}

const SectionDivider = styled.div<any>`
    padding: 15px 0;
    border-bottom: 1px solid ${colors.white25};
    ${(props: any): any => config(props).media.md`
    padding: 30px 0;
  `}
`
